"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDateTimeFilter = void 0;
const react_1 = require("react");
const reducer_1 = require("./reducer");
const useDateTimeFilter = (props) => {
    const [currentTab, setCurrentTab] = (0, react_1.useState)("relative");
    const [expressionMode, setExpressionMode] = (0, react_1.useState)(false);
    const [state, dispatch] = (0, react_1.useReducer)(reducer_1.dateTimeFilterReducer, (0, reducer_1.initializer)({ value: props?.value?.dateTime }));
    (0, react_1.useEffect)(() => {
        if (typeof props?.value?.dateTime === "string") {
            setExpressionMode(!state?.amount && !state?.unit);
            setCurrentTab("relative");
        }
        else if (typeof props?.value?.dateTime === "number") {
            setCurrentTab("absolute");
        }
    }, [props?.value?.dateTime]);
    (0, react_1.useEffect)(() => {
        if (!props?.onChange)
            return;
        props.onChange({ value: state?.value, absolute: state?.absolute });
    }, [state?.value]);
    return {
        value: state,
        currentTab,
        expressionMode,
        onTabChange: (value) => setCurrentTab(value),
        onToggleExpression: () => setExpressionMode(!expressionMode),
        onToggleStartOfUnit: () => {
            dispatch({
                type: reducer_1.DATE_TIME_FILTER_CHANGED,
                payload: { ...state, value: { amount: state?.amount, unit: state?.unit, startOfUnit: !state.startOfUnit } },
            });
        },
        onValueChange: (value) => {
            dispatch({ type: reducer_1.DATE_TIME_FILTER_CHANGED, payload: { ...state, value } });
        },
    };
};
exports.useDateTimeFilter = useDateTimeFilter;
